/* ShowFiltersButton.tsx generated by @compiled/babel-plugin v0.26.0 */
import { ax, ix, CC, CS } from "@compiled/react/runtime";
import Badge from '@atlaskit/badge';
import FilterIcon from '@atlaskit/icon/glyph/filter';
import { Inline, xcss } from '@atlaskit/primitives';
import Pressable from '@atlaskit/primitives/pressable';
import React from 'react';
const buttonStyles = xcss({
  width: '100%',
  borderRadius: 'border.radius.200',
  height: 'size.400',
  backgroundColor: 'color.background.neutral',
  color: 'color.text',
  fontSize: '0.875rem',
  fontWeight: 500,
  ':hover': {
    backgroundColor: 'color.background.neutral.hovered'
  },
  ':active': {
    backgroundColor: 'color.background.neutral.pressed'
  }
});
const buttonSelectedStyles = xcss({
  backgroundColor: 'color.background.selected',
  color: 'color.text.selected',
  ':hover': {
    backgroundColor: 'color.background.selected.hovered'
  },
  ':active': {
    backgroundColor: 'color.background.selected.pressed'
  }
});
export const ShowFiltersButton = _ref => {
  let {
    numberOfSelections,
    onClick,
    enableSort = false
  } = _ref;
  return /*#__PURE__*/React.createElement(Pressable, {
    onClick: onClick,
    xcss: [buttonStyles, numberOfSelections > 0 && buttonSelectedStyles]
  }, /*#__PURE__*/React.createElement(Inline, {
    alignInline: "center",
    alignBlock: "center",
    space: "space.050"
  }, /*#__PURE__*/React.createElement(FilterIcon, {
    label: ""
  }), enableSort ? 'Sort & filter' : 'Filter', numberOfSelections > 0 && /*#__PURE__*/React.createElement(Badge, {
    appearance: "primary"
  }, numberOfSelections)));
};